import store from '@/store'

export const optionButton = [
  {
    button: true,
    text: 'Padrão',
    funcaoButton: 'listarVagasReservadasProjeto',
    icon: 'edit',
    tooltip: 'Carregar padrão',
    objpermCodigo: store.state.permissaoMenu.editar
  },
  {
    button: true,
    text: 'Finalizar',
    funcaoButton: 'finalizaVagas',
    icon: 'check',
    tooltip: 'Finalizar',
    variant: 'primary',
    objpermCodigo: store.state.permissaoMenu.editar
  }
]
export const fieldsFinalizar = [
  {
    key: 'ordem',
    label: 'Ordem',
    sortable: true,
    tdClass: 'tdCadastro',
    type: 'input',
    tipo: 'number'
  },
  { key: 'idcampo', label: 'ID_Campo', sortable: true, tdClass: 'tdCadastro' },
  { key: 'valor', label: 'Valor', sortable: true, tdClass: 'tdCadastro', type: 'input' },
  {
    key: 'descricao',
    label: 'Descrição',
    sortable: true,
    type: 'input'
  },
  { key: 'actions', label: '' }
]
